import { styled } from 'stitches.config'

export const CustomerReviewRoot = styled('div', {
  position: 'relative',
  width: '100%',
  background: '$tertiary-200',
  overflow: 'hidden',
  zIndex: 0,

  maxWidth: '1920px',
  margin: 'auto',

  '& .d-only': {
    display: 'none',
  },
  '& .m-only': {
    display: 'block',
  },
  '@bp3': {
    '& .d-only': {
      display: 'block',
    },
    '& .m-only': {
      display: 'none',
    },
  },
})

export const ReviewCard = styled('div', {
  position: 'absolute',
  background: '$accent-white',
  borderRadius: '30px',
  padding: '40px',
  maxWidth: '290px',
  width: '100%',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$4',
  bottom: '0px',
  left: 0,
  right: 0,
  margin: 'auto',
  zIndex: 2,

  '& > div': {
    margin: 0,
  },

  '@bp3': {
    width: '420px',
    padding: '60px 80px',
    top: '10%',
    left: '10%',
    right: 'unset',
    bottom: 'unset',
    margin: 'none',
    maxWidth: 'none',
  },
})

export const CustomerName = styled('p', {
  fontFamily: '$primary',
  fontSize: '$bodyExtraLarge',
  fontWeight: '$regular',
  color: '$accent-black',

})

export const BorderWrapper = styled('div', {
  position: 'absolute',
  zIndex: 1,
  right: 0,
  left: 0,
  margin: 'auto',
  background: 'transparent',

  bottom: '200px',

  '@bp3': {
    bottom: 0,
  },
})

export const DesktopImage = styled('div', {
  display: 'none',
  margin: 'auto',
  position: 'relative',
  '@bp3': {
    display: 'block',
    maxWidth: '1920px',
  },
})

export const MobileImage = styled('div', {
  display: 'block',
  maxWidth: '375px',
  margin: 'auto',
  position: 'relative',
  zIndex: 1,
  '@bp3': {
    display: 'none',
  },
})

export const Spacer = styled('div', {
  height: '200px',
})
